export const BOOLEAN_RADIO_GROUP_NAME = 'lever-boolean-value'
